<template>
  <div id="marketFrontend">
    <!-- header -->
    <section
      class="pageHeader"
      :class="locale == 'en' ? 'pageHeaderLtl' : 'pageHeaderRtl'"
    >
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="7" class="header-content">
            <div class="first-half">
              <div class="content">
                <h1 class="main-title">{{ $t("marketTitle") }}</h1>
                <p class="desc mt-4">
                  {{ $t("Market Description") }}
                </p>
                <div class="btns mt-8">
                  <v-btn
                    class="primary-btn"
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                    router
                    v-if="!teacherOrStudent"
                    href="#signupSection"
                  >
                    <!-- @click="goToEducationalSection" -->
                    <img
                      src="../assets/images/edu.png"
                      class="img-icon"
                      width="70px"
                    />
                    <span class="btn-content">
                      {{ $t("joinEducationalPlateform") }}
                    </span>
                  </v-btn>
                  <v-btn
                    class="second-btn main-grey pt-2"
                    large
                    router
                    to="/market"
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                  >
                    <img
                      src="../assets/images/market.png"
                      class="img-icon"
                      width="70px"
                    />
                    <span class="btn-content">
                      {{ $t("goToStore") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- feature -->
    <section class="features">
      <v-container>
        <v-row>
          <v-col cols="12" md="3" sm="6">
            <div class="item text-center">
              <v-icon large class="icon">video_call</v-icon>
              <p class="title">{{ $t("feature1") }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <div class="item text-center">
              <v-icon class="icon">menu_book</v-icon>
              <p class="title">{{ $t("feature4") }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <div class="item text-center">
              <v-icon class="icon">payment</v-icon>
              <p class="title">{{ $t("feature3") }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <div class="item text-center">
              <v-icon large class="icon">access_time</v-icon>
              <p class="title">{{ $t("feature2") }}</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- signup -->
    <section class="signupSection" id="signupSection" v-if="!teacherOrStudent">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="section-title text-center white--text">
              {{ $t("createAccount") }}
            </h2>
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="8" offset-lg="2">
            <v-row>
              <v-col>
                <div class="btns text-center">
                  <v-btn
                    class="primary-btn"
                    large
                    router
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                    to="/studentsignup"
                  >
                    <img
                      src="../assets/images/student.png"
                      width="50px"
                      class="student-icon img-icon"
                    />
                    <span class="btn-content">
                      {{ $t("IAMStudent") }}
                    </span>
                  </v-btn>

                  <v-btn
                    class="second-btn main-grey btn-with-icon"
                    large
                    router
                    :class="
                      locale == 'en' ? 'btn-with-icon' : 'btn-with-icon-rtl'
                    "
                    to="/teachersignup"
                  >
                    <img
                      src="../assets/images/teacher.png"
                      width="50px"
                      class="teacher-icon img-icon"
                    />
                    <span class="btn-content">
                      {{ $t("IAMTeacher") }}
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- educationsTools -->
    <section class="educationsTools">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="section-title text-center white--text">
              {{ $t("sellEducationalTools") }}
            </h2>
          </v-col>

          <v-col cols="12" sm="6" md="6" offset-sm="3">
            <v-row>
              <v-col>
                <div class="image-div text-center">
                  <img src="../assets/images/books.png" alt="" />
                </div>
              </v-col>
              <v-col>
                <div class="image-div text-center">
                  <img src="../assets/images/uniform.png" alt="" />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn link class="third-btn" to="/comingsoon">
                  <v-icon>shopping_basket</v-icon>
                  <span>
                    {{ $t("Go to store") }}
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="products" style="display: none">
      <v-container>
        <h2 class="section-title">{{ $t("ourOnlineProducts") }}</h2>

        <v-row>
          <v-col cols="12" sm="3" md="3" @click="viewProduct(1)">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small color="yellow"></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3" @click="viewProduct(1)">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3" @click="viewProduct(1)">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3" @click="viewProduct(1)">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="teachers" v-if="teachers.length > 0 && type != 'Teacher'">
      <v-container>
        <h2 class="section-title" v-if="!isLoggedIn">{{ $t("teachers") }}</h2>
        <h2 class="section-title" v-else>
          <router-link
            to="/teachers"
            class="main-color"
            style="text-decoration: none"
            >{{ $t("teachers") }}</router-link
          >
        </h2>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="teacher"
            v-for="(teacher, index) in teachers"
            :key="index"
          >
            <v-card
              class="mx-auto"
              outlined
              elevation="1"
              :to="isLoggedIn ? '/teachers/' + teacher.id : '#'"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    :src="teacher.img"
                    class="teacher-image"
                    alt
                    v-if="teacher.img"
                  />
                  <img
                    src="../assets/images/women.png"
                    class="teacher-image"
                    alt
                    v-else
                  />
                  <p class="text-center teacher-name mb-2">
                    {{ teacher.name }}
                  </p>
                  <div class="text-center chips mb-2">
                    <v-chip
                      class="ma-1 v-chip"
                      color="#13a8b1"
                      v-for="(subject, index) in teacher.subjects"
                      :key="index"
                      >{{ subject }}</v-chip
                    >
                  </div>
                  <div class="details">
                    <p class="subject text-center">
                      <v-icon color="#ffc382">subject</v-icon>
                      {{ teacher.curriculum }}
                    </p>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- testimonials -->
    <section class="testimonials" style="display: none">
      <v-container>
        <h2 class="section-title">اراء المستخدمين</h2>
        <v-row>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/female.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/male.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/female.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- ====================== newsletter ==================== -->
    <section class="newsletters" style="display: none">
      <v-container>
        <h2 class="section-title">{{ $t("subscribeToOurNewsletters") }}</h2>
        <v-row>
          <v-col cols="8" sm="8">
            <v-text-field label="" single-line outlined></v-text-field>
          </v-col>
          <v-col cols="4" sm="4">
            <v-btn large class="primary-btn">{{ $t("Subscribe") }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import AUTH from "../auth";
export default {
  name: "landingPage",
  data() {
    return {
      // page: 1,
      // total: 12,
      teachers: [],
      locale: localStorage.locale,
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,
      teacherOrStudent: AUTH.teacherOrStudent(),
      type: AUTH.type(),
    };
  },
  methods: {
    goToLoginPage() {
      this.$router.push({ path: "/login" });
    },
    setDefaultLocale() {
      if (localStorage.locale == undefined) {
        localStorage.locale = "ar";
        window.location.reload();
      }
    },

    getTeachers() {
      this.$http
        .get(this.getApiUrl + "/teachers", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.teachers = response.data.data;
            // this.page = response.data.data.current_page;
            // this.total = response.data.data.last_page;
          }
        });
    },
    viewProduct() {
      this.$router.push({ path: "/market/product/1" });
    },
    goToEducationalSection() {
      window.scrollTo(0, 850);
    },
  },
  mounted() {
    this.setDefaultLocale();
    this.getTeachers();
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";
@import "../assets/styles/_responsive.scss";

#marketFrontend {
  .pageHeaderRtl {
    background-image: url("../assets/images/arabic_cover.png");
  }
  .pageHeaderLtl {
    background-image: url("../assets/images/english_cover.png");
  }
  .pageHeader {
    min-height: 35rem;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;

    .first-half {
      margin-top: 30%;

      .main-title {
        color: $main-grey;
      }

      .desc {
        color: $main-grey;
      }

      .btns {
        .btn-with-icon {
          padding: 0px 15px 0 0px !important;
          width: 16rem;
          border-radius: 7px !important;

          .img-icon {
            position: absolute;
            left: 0;
            bottom: -10px;
          }
          .btn-content {
            margin-left: 4rem;
            display: inline-block;
          }
        }
        .btn-with-icon-rtl {
          padding: 0px 0 0 15px !important;
          width: 16rem;
          border-radius: 7px !important;
          .img-icon {
            position: absolute;
            right: 0;
            bottom: -10px;
          }

          .btn-content {
            margin-right: 4rem;
            display: inline-block;
          }
        }
        .v-btn {
          border-color: #ffffff;
          color: #ffffff;
          margin: 0 0.5rem;
          margin-bottom: 1rem !important;
        }
      }

      @media (min-width: 600px) {
        .btns {
          .v-btn {
            margin: 0 0.5rem !important;
          }
        }
      }
    }
  }
}

/* features section */
.features {
  margin-top: $margin-top;
  .item {
    max-width: 80%;
    margin: 0 auto;
    .title {
      margin-top: 1rem;
      color: $main-color !important;
      font-size: 1.5rem !important;
      font-weight: 700;
      line-height: 2rem;
    }
    .v-icon {
      font-size: 4rem !important;
      color: $second-color;
    }
  }
}

/* signupSection */
.signupSection {
  min-height: 25rem;
  background-image: url("../assets/images/signup-section.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;

  .btn-with-icon {
    width: 16rem;
    border-radius: 7px !important;
    .img-icon {
      position: absolute;
      left: 0;
      bottom: -10px;
      margin-bottom: 0 !important;
    }

    .btn-content {
      margin-left: 4rem;
      display: inline-block;
    }
  }
  .btn-with-icon-rtl {
    border-radius: 7px !important;
    width: 16rem;
    .img-icon {
      position: absolute;
      right: 0;
      bottom: -10px;
      margin-bottom: 0 !important;
    }
    .btn-content {
      margin-right: 4rem;
      display: inline-block;
    }
  }

  .section-title {
    margin-top: 5% !important;
    color: #ffffff !important;
    margin-bottom: 3rem;
  }

  .btns {
    .teacher-icon {
      margin-bottom: 100%;
    }
    .student-icon {
    }
    .v-btn {
      border-color: #ffffff;
      color: #ffffff !important;
    }
  }

  @media (min-width: 600px) {
    .btns {
      .v-btn {
        margin: 20px !important;
      }
    }
  }
}

.educationsTools {
  .third-btn {
    text-transform: capitalize;
    font-size: 1.2rem;
    .v-icon {
      margin: 0 10px !important;
    }
  }
}

/* products */
.products {
  margin-top: $margin-top;
  .product {
    position: relative;
    // max-width: 90% !important;
    img {
      max-width: 100% !important;
      margin: 0 auto;
      width: 100%;
    }
    .product-info {
      background-color: $home-overlay;
      width: 100% !important;
      color: #ffffff;
      // opacity: 0.8;
      text-align: center !important;
      position: absolute;
      bottom: 6px;
      p {
        margin-bottom: 2px;
      }
      .v-icon {
        font-size: larger !important;
      }
    }
  }
}

/* teacher section */
.teachers {
  margin-top: $margin-top;

  .v-card {
    height: 300px !important;
  }
  .teacher-image {
    max-width: 100px;
    max-height: 100px;
    margin: 0 auto !important;
    border-radius: 50%;
  }
  .teacher-name {
    color: $main-color;
    margin-top: 1rem !important;
    font-weight: bold !important;
  }
  .chips {
    .v-chip {
      color: #ffffff !important;
      background-color: rgb(19 168 177 / 50%) !important;
      .v-size--default {
        font-size: 10px;
      }
    }
  }

  .details {
    color: $second-color;
    p {
      margin-bottom: 0 !important;
      font-size: 0.8rem !important;
    }
  }
}

.testimonials {
  .item {
    .client-image {
      max-width: 50px !important;
      max-height: 50px !important;
      border-radius: 50%;
      margin: 0 auto !important;
      border: 3px solid $third-color;
    }
    .client-name {
      color: $main-color !important;
      font-size: 1rem !important;
      font-weight: bold;
    }
    .desc {
      color: #888888 !important;
      font-size: 0.8rem !important;
    }
  }
}
</style>
